const testingUrls = {
    fetchTests: {
        url: '/testing/'
    },
    fetchTest: {
        url: '/testing/:id'
    },
    fetchFormOptions: {
        url: '/testing/actions/formOptions'
    },
    fetchPositionFormOptions: {
        url: '/testing/actions/positionFormOptions'
    },
    fetchTestingQuestions: {
        url: '/testing/:id/questions'
    },
    importQuestions: {
        url: '/testing/:id/importQuestions'
    },
    fetchPositions: {
        url: '/testing/:id/positions'
    },
    fetchNrkPositions: {
        url: '/testing/:id/nrkPositions'
    },
    removePosition: {
        url: '/testing/:id/removePosition'
    },
    addPosition: {
        url: '/testing/:id/addPosition'
    },
    fetchTestingTypesForSettings:{
        url:'/testing/settings/testingTypes'
    },
    fetchTestingType:{
        url:'/testing/types/:id'
    },
    fetchTestingTypeSettingsOptions:{
        url:'/testing/actions/settingsOptions'
    },
    addTestingTypeSettings:{
        url:'/testing/settings/addTestingTypeSettings'
    },
    updateTestingTypeSettings:{
        url:'/testing/settings/updateTestingTypeSettings'
    }
};

export default testingUrls;
